import { createTheme } from "@mui/material";
import { customColorsPallet } from "~/shared/mui/theme_utils";

// used to get its augmentColor method, which needs threshold, etc.
// we'll need to duplicate the threshold, etc. in the theme because I can't get it to work otherwise
const baseTheme = createTheme({
  palette: {
    contrastThreshold: 1.5, // Increased for better WCAG AA compliance
    tonalOffset: 0.04, // Increased for more distinct hover states
  } as any, // Need to bypass type checking since we're configuring base palette properties
})

export const theme = createTheme({
  defaultColorScheme: 'light',
  cssVariables: {
    colorSchemeSelector: 'class' //stops mode from responding to system
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
          '&:active': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.94)',
            backdropFilter: 'blur(4px)',
          },
        },
      },
    },
  },
  typography: {
    fontSize: 18,
    h1: {
      fontSize: '2rem',
    },
    h2: {
      fontSize: '1.8rem',
    },
    h3: {
      fontSize: '1.5rem',
    },
    h4: {
      fontSize: '1.25rem',
    },
  },
  colorSchemes: {
    dark: {
      palette: {
        action: {
          active: '#D6D6D6',
        },
        primary: {
          main: '#0f5492',
        },
        secondary: {
          main: '#03dac6',
        },
        ...customColorsPallet(baseTheme),
      }
    },
    light: {
      palette: {
        action: {
          active: '#000',
        },
        primary: {
          main: '#0f5492',
        },
        secondary: {
          main: '#03dac6',
        },
        ...customColorsPallet(baseTheme),
      }
    }
  }
});
